import React, { useState } from "react";
import Sketch from "react-p5";

const Mountains = () => {
  const [fly, setFly] = useState(0);
  const w = 1980;
  const h = 400;
  const scale = 20;
  const rows = h / scale;
  const cols = w / scale;
  let mountains = Array.from({ length: rows }, () => []);

  const setup = (p5, canvasParentRef) => {
    p5.createCanvas(w, h, p5.WEBGL).parent(canvasParentRef);
    p5.background(0);
    // p5.noStroke();
  };

  const draw = (p5) => {
    p5.clear();
    // p5.background(0);
    setFly((prevFly) => prevFly + 0.01);

    let yOff = fly;

    for (let i = 0; i < rows; i++) {
      mountains[i] = [];
      let xOff = 0;
      for (let j = 0; j < cols; j++) {
        mountains[i][j] = p5.map(p5.noise(xOff, yOff), 0, 1, -40, 60);
        xOff += 0.3;
      }
      yOff += 0.3;
    }

    p5.rotateX(p5.PI / 3);
    p5.translate(-w / 2, -h / 2);

    for (let i = 0; i < rows - 1; i++) {
      p5.beginShape(p5.TRIANGLE_STRIP);
      for (let j = 0; j < cols; j++) {
        const height = mountains[i][j];

        const r = p5.map(height, -40, 120, 20, 200);
        const g = p5.map(height, -40, 60, 100, 0);
        const b = 0;

        // const r = p5.map(height, -40, 60, 20, 86);
        // const g = p5.map(height, -40, 60, 67, 16);
        // const b = p5.map(height, -40, 60, 44, 5);

        p5.fill(r, g, b);
        p5.vertex(j * scale, i * scale, height);
        p5.vertex(j * scale, (i + 1) * scale, mountains[i + 1][j]);
      }
      p5.endShape();
    }
  };

  return <Sketch setup={setup} draw={draw} />;
};

export default Mountains;
